<button class="close" mat-button (click)="close()">X</button>
<h3 mat-dialog-title>Add member.</h3>
<mat-dialog-content class="change-bg">
    <mat-spinner style="margin: auto;" *ngIf="showSpinner; else showContent" ></mat-spinner>
    <ng-template #showContent>
        <form [formGroup]="phoneNumberToAdd" >
            <mat-form-field appearance="fill">
              <mat-label>Add Number</mat-label>
              <input matInput formControlName="phoneNumber" required>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Description</mat-label>
                <input matInput formControlName="description" >
            </mat-form-field><br>
            <button mat-mini-fab color="primary" (click)="save()">
                <mat-icon>add</mat-icon>
            </button>
            <!-- <mat-icon (click)="save()" style="color: green;">library_add</mat-icon> -->
        </form>
        <br>
        <table class="table table-striped table-hover" data-row-style="rowStyle">
            <thead>
                <tr class="t-header">
                    <th>
                        Phone Number
                    </th>
                    <th>
                        Description
                    </th>
                    <th>
                        Delete
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of tableData let indexOfelement=index;">
                    <td>
                        {{data.phone}}
                    </td>
                    <td>
                        {{data.description}}
                    </td>
                    <td>
                        <mat-icon (click)="deleteNumber(indexOfelement)">delete</mat-icon>
                    </td>
                </tr>
            </tbody>
        </table>
    </ng-template>
</mat-dialog-content>
<!-- 
<mat-dialog-actions>
    <button class="mat-raised-button"(click)="close()">Close</button>&nbsp;
</mat-dialog-actions> -->